module.exports = __webpack_public_path__ + "img/verified.ede30244.svg";